
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/label-library/graphic-ticket-files",
      function () {
        return require("private-next-pages/my-account/label-library/graphic-ticket-files.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/label-library/graphic-ticket-files"])
      });
    }
  